import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import couponIcon from "assets/icons/coupon.svg";
import "./DealBanner.scss";

export default function DealBanner({ className, text }) {
	return (
		<div className={classnames("deal-banner", className)}>
			<img src={couponIcon} alt="" className="deal-banner-icon" aria-hidden="true" />
			<span className="deal-banner-text">{text}</span>
		</div>
	);
}

DealBanner.propTypes = {
	className: PropTypes.string,
	text: PropTypes.string.isRequired,
};
